<template>
  <zul-modal
    id="access-validation-modal"
    class="is-small"
    ref="modal"
    :hasClose="hasClose"
  >
    <div class="validation-wrapper">
      <div class="validation-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
          <path
            d="M80 192V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H80zM144 192H304V144C304 99.82 268.2 64 224 64C179.8 64 144 99.82 144 144V192z"
          />
        </svg>
      </div>

      <h3 class="validation-title">{{ info.title }}</h3>

      <p class="validation-text">{{ info.text }}</p>

      <span class="validation-email">
        {{ info.email }}
      </span>

      <button
        ref="button"
        class="button is-primary is-medium validation-button"
        @click="confirm"
      >
        {{ info.actionLabel }}
      </button>
    </div>
  </zul-modal>
</template>

<script>
export default {
  name: "AccessValidationModal",
  props: {
    info: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      hasClose: false,
    };
  },
  mounted() {
    this.$root.$on("open-access-validation-modal", () => {
      this.$refs.modal.open();
    });

    this.$root.$on("close-access-validation-modal", () => {
      this.$refs.modal.close();
    });
  },
  destroyed() {
    this.$root.$off("open-access-validation-modal");
    this.$root.$off("close-access-validation-modal");
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/variables";

.validation-wrapper {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  gap: 20px;
}

.validation-icon {
  width: 80px;
  height: 80px;
  margin-top: 15px;

  svg {
    width: 80px;
    height: 80px;

    > path {
      fill: $primarySAO;
    }
  }
}

.validation-title {
  font-size: 21px;
  font-weight: 700;
}

.validation-text {
  font-size: 18px;
  font-weight: 700;
  color: #9b9b9b !important;
  width: 250px;
  text-align: center;
}

.validation-email {
  font-size: 18px;
  font-weight: 700;
  color: $primarySAO !important;
}

.validation-button {
  height: 50px;
  border-radius: 50px;
  width: 200px;
  display: inline-flex;
  font-weight: 700;
  margin: 10px auto 0;
}
</style>
